import * as types from './index';

export const validateClientAddAction = (data) => {
    return {
        type: types.VALIDATE_CLIENT_ADD,
        data
    }
};

export const validateEventAddAction = (data) => {
    return {
        type: types.VALIDATE_EVENT_ADD,
        data
    }
};

export const validateClientDetailsAction = (data) => {
    return {
        type: types.VALIDATE_CLIENT_DETAILS,
        data
    }
}; 

export const validateCrewAddAction = (data) => {
    return {
        type: types.VALIDATE_CREW_ADD,
        data
    }
}; 

export const validateCrewDetailsAction = (data) => {
    return {
        type: types.VALIDATE_CREW_DETAILS,
        data
    }
}; 

